"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _icon = _interopRequireDefault(require("../icon"));
var _CustomMenuList = _interopRequireDefault(require("./CustomMenuList.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CustomMenuList = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomMenuList, _React$Component);
  var _super = _createSuper(CustomMenuList);
  function CustomMenuList(props) {
    var _this;
    _classCallCheck(this, CustomMenuList);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.setState({
        isExpanded: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleMenuVisibility", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      });
    });
    _this.state = {
      isExpanded: false
    };
    return _this;
  }
  _createClass(CustomMenuList, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        menuConfig = _this$props.menuConfig,
        className = _this$props.className,
        ariaLabel = _this$props.ariaLabel;
      var isExpanded = this.state.isExpanded;
      return /*#__PURE__*/_react["default"].createElement(_CustomMenuList["default"], {
        className: className
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "content-toggler ".concat(isExpanded ? 'active' : ''),
        onClick: this.toggleMenuVisibility,
        onKeyDown: this.toggleMenuVisibility,
        role: "button",
        "aria-label": ariaLabel || 'Expand menu',
        tabIndex: "0"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        className: "icon-ion-android-more-vertical"
      })), isExpanded && /*#__PURE__*/_react["default"].createElement("ul", {
        className: "menu-list"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        id: "report-menu-close",
        icon: "ion-close-circled",
        size: 18,
        className: "report-menu-close-icon",
        "aria-label": "Close pop-up",
        onClick: this.handleClickOutside
      }), R.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: "menu-item ".concat(item.disabled ? 'disabled' : ''),
          onClick: _this2.handleClickOutside,
          onKeyDown: _this2.handleClickOutside,
          role: "presentation",
          key: item.key || item.icon
        }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
          className: item.icon,
          size: item.iconSize
        }), item.menuItemRenderer());
      }, menuConfig)));
    }
  }]);
  return CustomMenuList;
}(_react["default"].Component);
CustomMenuList.defaultProps = {
  className: '',
  ariaLabel: ''
};
CustomMenuList.propTypes = {
  menuConfig: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].arrayOf(_propTypes["default"].shape({}))]).isRequired,
  className: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string
};
CustomMenuList.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleClickOutside",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "toggleMenuVisibility",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "CustomMenuList",
  "props": {
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ariaLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "menuConfig": {
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "shape",
          "value": {}
        }, {
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {}
          }
        }]
      },
      "required": true
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)((0, _reactClickOutside["default"])(CustomMenuList));
exports["default"] = _default;